import { useQueryClient } from '@tanstack/react-query';
import { assert } from '@varos/util-typescript';
export function createWorkspaceRepository(config) {
    const { repository, client } = config;
    function getFindKey() {
        return ['workspace', 'find'];
    }
    function getLookupKey(props) {
        return ['workspace', 'lookup', props.default, props.autocreate];
    }
    return {
        useFind(context, props, options) {
            const query = repository.useQuery({
                ...options,
                queryKey: getFindKey(),
                async queryFn() {
                    const response = await client.user.default.workspaceList(props);
                    return response.data.data;
                },
            });
            return query;
        },
        useLookup(context, props, options) {
            const query = repository.useQuery({
                ...options,
                queryKey: getLookupKey(props),
                async queryFn() {
                    const workspaces = await client.user.default.workspaceList({
                        limit: 10,
                    });
                    const [first, ...rest] = workspaces.data.data;
                    if (first) {
                        return first;
                    }
                    assert(props.autocreate, 'expected autocreate');
                    assert(context.principal, 'expected account principal when autocreating workspace');
                    console.info(`autocreating workspace...`);
                    const response = await client.admin.adminWorkspaceCreate({
                        adminWorkspaceCreatePayload: {
                            display_name: 'Default',
                        },
                    });
                    console.info(`autocreated workspace: ${response.data.id}`, response.data);
                    return response.data;
                },
            });
            return query;
        },
        useCreate(context) {
            const queryClient = useQueryClient();
            return repository.useMutation(context, {
                async mutationFn(props) {
                    const response = await client.admin.adminWorkspaceCreate({
                        adminWorkspaceCreatePayload: props,
                    });
                    return response.data;
                },
                onSuccess(data) {
                    const queryKey = getFindKey();
                    queryClient.setQueryData(queryKey, (old) => {
                        return [...(old ?? []), data];
                    });
                    queryClient.invalidateQueries({ queryKey: getFindKey() });
                },
            });
        },
    };
}
//# sourceMappingURL=workspaceRepository.js.map